interface Address {
  id: string;
  userId: string;
  name: string;
  phone: string;
  addressLine: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  landMark: string | null;
  isDefault: boolean;
  created_at: string;
  updated_at: string;
}

interface OrderItem {
  id: string;
  orderId: string;
  productId: string;
  productName: string;
  thumbnail: string;
  quantity: number;
  price: string;
  totalPrice: string;
  created_at: string;
  updated_at: string;
}

export type PaymentStatus = "PAID" | "PENDING" | "FAILED";
export type OrderStatus =
  "CREATED"
  | "PENDING"
  | "PAID"
  | "PLACED"
  | "SHIPPED"
  | "DELIVERED"
  | "CANCELLED"
  | "FAILED";

export interface Order {
  order_id: string;
  order_number: string;
  user_id: string;
  shipping_address_id: string;
  discount_applied: string;
  address: Address;
  order_items: OrderItem[];
  total_amount: string;
  payment_method: string;
  referred_by_name: string | null;
  referred_by_phone: string | null;
  refferal_code: string | null;
  payment_status: PaymentStatus;
  shipping_charge: string;
  status: OrderStatus;
  transaction_id: string;
  created_at: string;
  updated_at: string;
}

export interface OrderHistoryResponse {
  orders: Order[]; // Array of 0–N orders
}

export const statusStyles: Record<OrderStatus, string> = {
  PENDING: "bg-yellow-100 text-yellow-700 border-yellow-200",
  CREATED: "bg-yellow-100 text-yellow-700 border-yellow-200",
  PAID: "bg-blue-100 text-blue-700 border-blue-200",
  PLACED: "bg-green-100 text-green-700 border-green-200",
  SHIPPED: "bg-purple-100 text-purple-700 border-purple-200",
  DELIVERED: "bg-emerald-100 text-emerald-700 border-emerald-200",
  CANCELLED: "bg-red-100 text-red-700 border-red-200",
  FAILED: "bg-red-100 text-red-700 border-red-200",
};

export const paymentStatusStyles: Record<PaymentStatus, string> = {
  PENDING: "bg-yellow-100 text-yellow-700 border-yellow-200",
  PAID: "bg-green-100 text-green-700 border-green-200",
  FAILED: "bg-red-100 text-red-700 border-red-200",
};
